import { useContent } from "@/content/ContentProvider";
import React from "react";
import ShaderBackground from "@/components/site/ShaderBackground";
import { PillButton } from "@/components/site/Kit";
export default function NotFound() {
  const { text: cmsText } = useContent();
  return (
    <section
      className="relative flex min-h-screen items-end overflow-hidden bg-[#f7f7f7] px-5 pb-16 pt-32"
      data-testid="not-found"
    >
      <ShaderBackground strength={0.45} lines={12} fadeLeft={0.6} />
      <div className="relative z-10 mx-auto w-full max-w-[1400px]">
        <p className="text-[12px] opacity-50">
          {cmsText("NotFound.NotFound.error-404.157fc0")}
        </p>
        <h1 className="nm-title mt-4 text-[64px] leading-[0.95] sm:text-[120px]">
          {cmsText("NotFound.NotFound.this-page-has-left-the-building-.bb572c")}
        </h1>
        <p className="mt-6 max-w-[460px] text-[20px] leading-[1.25] tracking-[-0.02em] opacity-70">
          {cmsText(
            "NotFound.NotFound.like-all-our-projects-it-was-handed-over-and-.4953a5",
          )}
        </p>
        <div className="mt-8 flex gap-2">
          <PillButton to="/" size="lg">
            {cmsText("NotFound.NotFound.back-home.5c53da")}
          </PillButton>
          <PillButton to="/contact" size="lg" variant="white" icon={false}>
            {cmsText("NotFound.NotFound.contact-us.4832e4")}
          </PillButton>
        </div>
      </div>
    </section>
  );
}
